import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import useUser from 'hooks/useUser';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';

type Props = {
  children?: JSX.Element;
  needsSession: boolean;
  redirectPath: string;
};
export function AuthGuard({ needsSession, redirectPath, children }: Props) {
  const { userResult, clearUserState } = useUser();
  const location = useLocation();

  // If the user is redirected here because of a 401, we need to clear the user state and ensure they're not redirected to an auth protected page.
  if (location.state?.received401) {
    clearUserState();
  }

  if (userResult?.loading) return <LoadingLogo />;

  const hasSession = Boolean(userResult?.user);
  let isAllowed = false;

  if (needsSession && hasSession) isAllowed = true;

  if (!needsSession && !hasSession) isAllowed = true;

  if (!isAllowed) {
    return <Navigate to={redirectPath} replace state={{ path: location.pathname }} />;
  }

  return children || <Outlet />;
}

export default AuthGuard;
